import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRegisterMutation } from "../../redux/slices/usersApiSlice";
import { useDispatch, useSelector } from "react-redux";
import { setCredentials } from "../../redux/slices/authSlice";
import { toast } from "react-toastify";
import { IoClose } from "react-icons/io5";
import { useDropzone } from "react-dropzone";
import PhoneInput from "react-phone-input-2";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import "react-phone-input-2/lib/style.css";
import imageCompression from "browser-image-compression";

const Register = () => {
    const [name, setName] = useState("");
    const [faze, setFaze] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [phone, setPhone] = useState("");
    const [finCode, setFinCode] = useState("");
    const [card, setCard] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [photo, setPhoto] = useState(null);

    // =========================================================
    // REFERRAL
    // =========================================================
    // URL-dən gələn əsas dəvət edən şəxsin kodu
    const [referralCode, setReferralCode] = useState("");

    // İstifadəçinin özünün seçdiyi lider kodu
    const [leaderCode, setLeaderCode] = useState("");

    // Lideri istifadəçi özü seçsin / sistem seçsin
    const [leaderSelection, setLeaderSelection] = useState("system");

    const [gender, setGender] = useState("");

    const [referralRequired, setReferralRequired] = useState(false);
    const [referralOwner, setReferralOwner] = useState(null);
    const [referralLoading, setReferralLoading] = useState(false);
    const [referralError, setReferralError] = useState("");

    const [showTerms, setShowTerms] = useState(false);
    const [acceptedTerms, setAcceptedTerms] = useState(false);

    const [formError, setFormError] = useState("");

    // =========================================================
    // QEYDİYYAT UĞURLU OLDUĞU ZAMAN CELEBRATION
    // =========================================================
    const [registrationSuccess, setRegistrationSuccess] =
        useState(false);

    const [successUser, setSuccessUser] = useState(null);

    const [countdown, setCountdown] = useState(10);

    const navigation = useNavigate();
    const dispatch = useDispatch();

    const [register, { isLoading }] = useRegisterMutation();

    const MAX_PHOTO_SIZE = 50 * 1024 * 1024;

    const userInfo = useSelector(
        (state) => state.auth?.userInfo
    );

    // =========================================================
    // ANA SƏHİFƏYƏ KEÇİD
    // =========================================================
    const goToHome = () => {
        setRegistrationSuccess(false);

        navigation("/", {
            replace: true,
        });
    };


    useEffect(() => {
        if (!registrationSuccess) return;

        setCountdown(10);

        const interval = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);

                    navigation("/", {
                        replace: true,
                    });

                    return 0;
                }

                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [registrationSuccess, navigation]);

    // =========================================================
    // XƏTA MESAJINI OXUNAQLI FORMAYA SALIR
    // =========================================================
    const getErrorMessage = (
        error,
        defaultMessage
    ) => {
        const responseData =
            error?.data ||
            error?.response?.data;

        if (
            typeof responseData === "string" &&
            responseData.trim()
        ) {
            return responseData;
        }

        if (responseData?.message) {
            return responseData.message;
        }

        if (responseData?.details) {
            return responseData.details;
        }

        if (responseData?.error) {
            return responseData.error;
        }

        if (error?.message) {
            return error.message;
        }

        if (error?.response?.status) {
            switch (
            error.response.status
            ) {
                case 400:
                    return "Göndərilən məlumatlar düzgün deyil. Zəhmət olmasa daxil etdiyiniz məlumatları yoxlayın.";

                case 401:
                    return "Məlumatların yoxlanılması zamanı icazə problemi yarandı.";

                case 403:
                    return "Bu əməliyyatı həyata keçirmək üçün icazəniz yoxdur.";

                case 404:
                    return "Qeydiyyat xidməti tapılmadı.";

                case 409:
                    return "Bu məlumatlarla artıq qeydiyyatdan keçmiş istifadəçi mövcuddur.";

                case 422:
                    return "Daxil etdiyiniz məlumatlardan biri düzgün deyil.";

                case 500:
                    return "Serverdə daxili xəta baş verdi. Zəhmət olmasa bir qədər sonra yenidən cəhd edin.";

                default:
                    return `Server xətası baş verdi. Xəta kodu: ${error.response.status}`;
            }
        }

        if (!error?.response) {
            return "Serverə qoşulmaq mümkün olmadı. İnternet bağlantınızı yoxlayın.";
        }

        return defaultMessage;
    };

    // =========================================================
    // REFERRAL MƏLUMATLARINI YÜKLƏ
    // =========================================================
    useEffect(() => {
        const params = new URLSearchParams(
            window.location.search
        );

        const code = params.get("referral");

        if (!code) {
            setReferralCode("");
            setReferralOwner(null);
            setReferralRequired(false);
            setReferralError("");
            setLeaderCode("");
            setLeaderSelection("system");

            return;
        }

        setReferralCode(code);
        setReferralLoading(true);
        setReferralError("");

        axios
            .get(
                `${process.env
                    .REACT_APP_API_BASE_URL
                }/api/users/admin/${encodeURIComponent(
                    code
                )}`
            )
            .then((res) => {
                const data =
                    res?.data || {};

                setReferralCode(code);

                setReferralRequired(
                    Number(data?.count || 0) >=
                    2
                );

                if (data?.owner) {
                    setReferralOwner(
                        data.owner
                    );

                    setReferralError("");
                } else {
                    setReferralOwner(null);

                    setReferralError(
                        "Bu dəvət koduna uyğun dəvət edən şəxs tapılmadı."
                    );
                }
            })
            .catch((error) => {
                console.error(
                    "Dəvət kodunun yoxlanılması zamanı xəta:",
                    error
                );

                setReferralOwner(null);
                setReferralRequired(false);

                setReferralError(
                    getErrorMessage(
                        error,
                        "Dəvət kodunu yoxlamaq mümkün olmadı."
                    )
                );
            })
            .finally(() => {
                setReferralLoading(false);
            });
    }, []);

    // =========================================================
    // LİDER SEÇİMİ DƏYİŞDİKDƏ
    // =========================================================
    const handleLeaderSelectionChange = (
        value
    ) => {
        setLeaderSelection(value);

        if (value === "system") {
            // Sistem seçirsə leaderCode göndərilmir
            setLeaderCode("");
        }
    };
    const compressProfilePhoto = async (file) => {
        const originalSizeKB = file.size / 1024;
        const originalSizeMB = file.size / (1024 * 1024);

        console.log("========================================");
        console.log("📸 SEÇİLƏN ŞƏKİL");
        console.log(
            `Original ölçü: ${originalSizeMB.toFixed(2)} MB`
        );
        console.log(
            `Original ölçü: ${originalSizeKB.toFixed(0)} KB`
        );
        console.log(
            `Format: ${file.type}`
        );
        console.log(
            `Ad: ${file.name}`
        );

        // 500 KB və aşağıdırsa compression etmirik
        if (file.size <= 500 * 1024) {
            console.log("✅ Şəkil artıq kiçikdir.");
            console.log(
                `📤 Serverə göndəriləcək: ${originalSizeMB.toFixed(2)} MB (${originalSizeKB.toFixed(0)} KB)`
            );
            console.log("========================================");

            return file;
        }

        console.log("🔄 Şəkil sıxılır...");

        const options = {
            maxSizeMB: 0.5,
            maxWidthOrHeight: 1000,
            useWebWorker: true,
            initialQuality: 0.8,
        };

        try {
            const compressedFile =
                await imageCompression(
                    file,
                    options
                );

            const compressedSizeKB =
                compressedFile.size / 1024;

            const compressedSizeMB =
                compressedFile.size /
                (1024 * 1024);

            const savedKB =
                originalSizeKB -
                compressedSizeKB;

            const savedPercent =
                ((file.size - compressedFile.size) /
                    file.size) *
                100;

            console.log("========================================");
            console.log("📸 ŞƏKİL SIKIŞDIRILDI");
            console.log(
                `Original: ${originalSizeMB.toFixed(2)} MB (${originalSizeKB.toFixed(0)} KB)`
            );
            console.log(
                `Sıxışdırılmış: ${compressedSizeMB.toFixed(2)} MB (${compressedSizeKB.toFixed(0)} KB)`
            );
            console.log(
                `Qənaət: ${savedKB.toFixed(0)} KB`
            );
            console.log(
                `Qənaət faizi: ${savedPercent.toFixed(1)}%`
            );

            // Compression nəticəsi originaldan böyükdürsə
            if (compressedFile.size >= file.size) {
                console.log(
                    "⚠️ Sıxılmış fayl originaldan kiçik olmadı."
                );
                console.log(
                    `📤 Serverə göndəriləcək: ${originalSizeMB.toFixed(2)} MB`
                );
                console.log("========================================");

                return file;
            }

            const finalFile =
                new File(
                    [compressedFile],
                    file.name.replace(
                        /\.[^/.]+$/,
                        ".jpg"
                    ),
                    {
                        type: "image/jpeg",
                        lastModified: Date.now(),
                    }
                );

            console.log(
                `📤 SERVERƏ GÖNDƏRİLƏCƏK REAL ÖLÇÜ: ${(finalFile.size / (1024 * 1024)).toFixed(2)} MB (${(finalFile.size / 1024).toFixed(0)} KB)`
            );

            console.log("========================================");

            return finalFile;

        } catch (error) {
            console.error(
                "❌ Şəkil sıxılarkən xəta:",
                error
            );

            console.log(
                `📤 Compression alınmadı. Serverə original göndərilir: ${originalSizeMB.toFixed(2)} MB`
            );

            console.log("========================================");

            return file;
        }
    };

    // =========================================================
    // QEYDİYYAT
    // =========================================================
    const handleRegister = async (e) => {
        e.preventDefault();

        setFormError("");

        if (password !== confirmPassword) {
            const message =
                "Şifrə və şifrə təkrarı eyni deyil.";

            setFormError(message);
            toast.error(message);

            return;
        }

        if (password.length < 8) {
            const message =
                "Şifrə ən azı 8 simvoldan ibarət olmalıdır.";

            setFormError(message);
            toast.error(message);

            return;
        }

        if (!gender) {
            const message =
                "Zəhmət olmasa cinsiyyətinizi seçin.";

            setFormError(message);
            toast.error(message);

            return;
        }

        if (!phone || phone.length < 8) {
            const message =
                "Zəhmət olmasa düzgün telefon nömrəsi daxil edin.";

            setFormError(message);
            toast.error(message);

            return;
        }

        if (!finCode.trim()) {
            const message =
                "FIN kodunu daxil edin.";

            setFormError(message);
            toast.error(message);

            return;
        }

        if (!acceptedTerms) {
            const message =
                "Qeydiyyatdan keçmək üçün şərtlər və qaydaları qəbul etməlisiniz.";

            setFormError(message);
            toast.error(message);

            return;
        }

        // =====================================================
        // ƏGƏR İSTİFADƏÇİ ÖZÜ LİDER SEÇİRSƏ
        // =====================================================
        if (
            leaderSelection === "manual" &&
            !leaderCode.trim()
        ) {
            const message =
                "Zəhmət olmasa lider kodunu daxil edin və ya lideri sistemin seçməsinə icazə verin.";

            setFormError(message);
            toast.error(message);

            return;
        }

        try {
            const formData =
                new FormData();

            formData.append(
                "name",
                name.trim()
            );

            formData.append(
                "faze",
                faze.trim()
            );

            formData.append(
                "phone",
                phone
            );

            formData.append(
                "finCode",
                finCode.trim()
            );

            formData.append(
                "card",
                card.trim()
            );

            formData.append(
                "email",
                email.trim()
            );

            // =================================================
            // ƏSAS REFERRAL KODU
            // BU URL-DƏN GƏLƏN DƏVƏT EDƏN ŞƏXSİN KODUDUR
            // =================================================
            formData.append(
                "referralCode",
                referralCode.trim()
            );

            // =================================================
            // LİDER KODU
            //
            // manual -> istifadəçinin yazdığı kod
            // system -> boş göndərilir
            // Backend özü ağacda yer tapır
            // =================================================
            formData.append(
                "leaderCode",
                leaderSelection === "manual"
                    ? leaderCode.trim()
                    : ""
            );

            formData.append(
                "password",
                password
            );

            formData.append(
                "gender",
                gender
            );

            if (photo) {
                const compressedPhoto =
                    await compressProfilePhoto(photo);

                formData.append(
                    "photo",
                    compressedPhoto
                );

                console.log(
                    "📤 FormData-ya əlavə edilən şəkil:",
                    `${(compressedPhoto.size / (1024 * 1024)).toFixed(2)} MB`
                );
            }

            const params =
                new URLSearchParams(
                    window.location.search
                );

            const referralLinkOwner =
                params.get(
                    "referral"
                );

            if (referralLinkOwner) {
                formData.append(
                    "referralLinkOwner",
                    referralLinkOwner
                );
            }

            const res =
                await register(
                    formData
                ).unwrap();

            // =====================================================
            // LOGIN MƏLUMATLARINI REDUX-A YAZ
            // =====================================================
            dispatch(
                setCredentials({
                    ...res,
                })
            );

            // =====================================================
            // CELEBRATION ÜÇÜN USER MƏLUMATLARINI SAXLA
            // =====================================================
            const registeredUser =
                res?.user ||
                res?.userInfo ||
                res?.data ||
                res;

            setSuccessUser(
                registeredUser
            );

            // =====================================================
            // QEYDİYYAT UĞURLU
            // =====================================================
            setRegistrationSuccess(
                true
            );
        } catch (error) {
            console.error(
                "Qeydiyyat zamanı xəta:",
                error?.data ||
                error?.response?.data ||
                error
            );

            const errorMessage =
                getErrorMessage(
                    error,
                    "Qeydiyyat zamanı gözlənilməz xəta baş verdi."
                );

            setFormError(
                errorMessage
            );

            toast.error(
                errorMessage
            );
        }
    };

    // =========================================================
    // ŞƏKİL YÜKLƏMƏ
    // =========================================================
    const onDrop = (
        acceptedFiles,
        fileRejections
    ) => {
        if (
            fileRejections?.length >
            0
        ) {
            const rejection =
                fileRejections[0];

            const hasSizeError =
                rejection?.errors?.some(
                    (item) =>
                        item.code ===
                        "file-too-large"
                );

            if (hasSizeError) {
                toast.error(
                    "Şəklin ölçüsü 50 MB-dan böyük ola bilməz."
                );
            } else {
                toast.error(
                    "Bu şəkli yükləmək mümkün olmadı. JPG, JPEG, PNG və digər şəkil formatlarından istifadə edin."
                );
            }

            return;
        }

        if (
            acceptedFiles.length > 0
        ) {
            const file =
                acceptedFiles[0];

            if (
                file.size >
                MAX_PHOTO_SIZE
            ) {
                toast.error(
                    "Şəklin ölçüsü 50 MB-dan böyük ola bilməz."
                );

                return;
            }

            setPhoto(file);
        }
    };

    const {
        getRootProps,
        getInputProps,
        isDragActive,
    } = useDropzone({
        accept: {
            "image/*": [],
        },
        maxSize:
            MAX_PHOTO_SIZE,
        multiple: false,
        onDrop,
    });

    const handleClearUploadPhoto =
        () => {
            setPhoto(null);

            toast.info(
                "Seçilmiş şəkil silindi."
            );
        };

    // =========================================================
    // ŞƏRTLƏR MODALI
    // =========================================================
    const toggleTermsModal =
        () => {
            setShowTerms(true);
        };

    const closeTermsModal =
        () => {
            setShowTerms(false);
        };

    const acceptTerms =
        () => {
            setAcceptedTerms(true);
            setShowTerms(false);

            toast.success(
                "Şərtlər və qaydalar qəbul edildi."
            );
        };

    // =========================================================
    // CELEBRATION EKRANI
    // =========================================================
    if (registrationSuccess) {
        const displayUser =
            successUser ||
            userInfo ||
            {};

        const displayName =
            displayUser?.name ||
            name ||
            "Yeni istifadəçi";

        const displayPhoto =
            displayUser?.photo ||
            displayUser?.profilePhoto ||
            displayUser?.avatar ||
            null;

        const firstLetter =
            String(displayName)
                .charAt(0)
                .toUpperCase();

        return (
            <div className="fixed inset-0 z-[99999] overflow-y-auto overflow-x-hidden bg-slate-950 text-white">

                {/* ARXA FON */}
                <div className="fixed inset-0 pointer-events-none">
                    <div className="absolute left-1/2 top-1/2 h-[520px] w-[520px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-indigo-600/20 blur-[120px] animate-pulse" />

                    <div className="absolute -left-40 -top-40 h-[420px] w-[420px] rounded-full bg-violet-600/20 blur-[100px]" />

                    <div className="absolute -bottom-40 -right-40 h-[420px] w-[420px] rounded-full bg-blue-600/20 blur-[100px]" />

                    <div
                        className="absolute inset-0 opacity-[0.035]"
                        style={{
                            backgroundImage:
                                "linear-gradient(rgba(255,255,255,.8) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.8) 1px, transparent 1px)",
                            backgroundSize:
                                "40px 40px",
                        }}
                    />
                </div>

                {/* CONFETTI */}
                <div className="pointer-events-none fixed inset-0 overflow-hidden">
                    {Array.from({
                        length: 34,
                    }).map(
                        (_, index) => (
                            <span
                                key={
                                    index
                                }
                                className="absolute h-2 w-2 rounded-sm bg-white/80"
                                style={{
                                    left: `${(index *
                                        29) %
                                        100
                                        }%`,
                                    top: "-20px",
                                    animation: `celebrationConfetti ${2.5 +
                                        (index %
                                            5) *
                                        0.35
                                        }s linear infinite`,
                                    animationDelay: `${(index %
                                        9) *
                                        0.16
                                        }s`,
                                    transform: `rotate(${index *
                                        27
                                        }deg)`,
                                }}
                            />
                        )
                    )}
                </div>

                {/* PARILTI NÖQTƏLƏRİ */}
                <div className="pointer-events-none fixed inset-0 overflow-hidden">
                    {Array.from({
                        length: 18,
                    }).map(
                        (_, index) => (
                            <span
                                key={`spark-${index}`}
                                className="absolute h-1.5 w-1.5 rounded-full bg-white shadow-[0_0_15px_rgba(255,255,255,0.9)] animate-ping"
                                style={{
                                    left: `${8 +
                                        ((index *
                                            37) %
                                            84)
                                        }%`,
                                    top: `${8 +
                                        ((index *
                                            47) %
                                            82)
                                        }%`,
                                    animationDelay: `${index *
                                        0.12
                                        }s`,
                                }}
                            />
                        )
                    )}
                </div>

                {/* ƏSAS MƏZMUN */}
                <div className="relative z-20 flex min-h-full w-full items-center justify-center px-4 py-12 sm:px-6">
                    <div className="w-full max-w-2xl my-auto text-center">

                        {/* ÜST ETİKET */}
                        <div
                            className="mb-5 inline-flex items-center gap-2 rounded-full border border-emerald-400/20 bg-emerald-400/10 px-4 py-2 text-xs font-bold uppercase tracking-[0.2em] text-emerald-300"
                            style={{
                                animation:
                                    "celebrationFadeUp .7s ease-out both",
                            }}
                        >
                            <span className="h-2 w-2 animate-pulse rounded-full bg-emerald-400" />
                            Qeydiyyat uğurla tamamlandı
                        </div>

                        {/* AVATAR */}
                        <div
                            className="relative mx-auto mb-7 h-32 w-32 sm:h-40 sm:w-40"
                            style={{
                                animation:
                                    "celebrationAvatar .9s cubic-bezier(.16,1,.3,1) both",
                            }}
                        >
                            <div className="absolute -inset-3 rounded-full border border-indigo-400/20 animate-pulse" />

                            <div className="absolute -inset-5 rounded-full border border-violet-400/10" />

                            <div className="absolute inset-0 rounded-full bg-indigo-500/30 blur-2xl" />

                            <div className="relative h-full w-full overflow-hidden rounded-full border-4 border-white/20 bg-gradient-to-br from-indigo-500 via-violet-500 to-purple-600 shadow-2xl shadow-indigo-500/40">
                                {displayPhoto ? (
                                    <img
                                        src={
                                            displayPhoto
                                        }
                                        alt={
                                            displayName
                                        }
                                        className="h-full w-full object-cover"
                                    />
                                ) : (
                                    <div className="flex h-full w-full items-center justify-center text-5xl font-black text-white sm:text-6xl">
                                        {
                                            firstLetter
                                        }
                                    </div>
                                )}
                            </div>

                            <div className="absolute -bottom-1 -right-1 flex h-10 w-10 items-center justify-center rounded-full border-4 border-slate-950 bg-emerald-500 text-white shadow-lg shadow-emerald-500/30 sm:h-12 sm:w-12">
                                <svg
                                    className="h-5 w-5 sm:h-6 sm:w-6"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="3"
                                        d="M5 13l4 4L19 7"
                                    />
                                </svg>
                            </div>
                        </div>

                        {/* TƏBRİKLƏR */}
                        <div
                            style={{
                                animation:
                                    "celebrationFadeUp .8s .15s ease-out both",
                            }}
                        >
                            <h1 className="text-4xl font-black tracking-tight sm:text-6xl md:text-7xl">
                                <span className="bg-gradient-to-r from-white via-indigo-200 to-violet-300 bg-clip-text text-transparent">
                                    TƏBRİKLƏR!
                                </span>
                            </h1>

                            <div className="mt-3 text-lg font-bold text-white sm:text-2xl">
                                Xoş gəlmisiniz,{" "}
                                <span className="text-indigo-300">
                                    {
                                        displayName
                                    }
                                </span>{" "}
                                👋
                            </div>
                        </div>

                        {/* ƏSAS MƏTN */}
                        <div
                            className="mx-auto mt-7 max-w-xl"
                            style={{
                                animation:
                                    "celebrationFadeUp .8s .3s ease-out both",
                            }}
                        >
                            <p className="text-base leading-7 text-slate-300 sm:text-lg sm:leading-8">
                                Bu gündən etibarən siz də{" "}
                                <span className="font-bold text-white">
                                    artim.shop
                                </span>{" "}
                                ailəsinin bir hissəsisiniz.
                            </p>

                            <p className="mt-4 text-sm leading-6 text-slate-400 sm:text-base sm:leading-7">
                                Burada məqsəd sadəcə alış-veriş etmək deyil.
                                Məhsullarınızı təqdim edə, elanlar yerləşdirə,
                                alıb-sata və öz komandanizi qurub onu genişləndirə
                                maaş və hər dəvət etdiyin komanda üzvündən qazanc
                                əldə edə bilərsiniz.
                            </p>

                            <p className="mt-4 text-sm font-semibold leading-6 text-indigo-200 sm:text-base">
                                Böyük işlər çox vaxt kiçik bir addımla başlayır. 🚀
                                <br />
                                Bu gün isə həmin addımı siz atdınız.
                            </p>
                        </div>

                        {/* ARTIM SHOP KARTI */}
                        <div
                            className="mx-auto mt-7 max-w-xl rounded-3xl border border-white/10 bg-white/[0.04] p-5 text-left shadow-2xl backdrop-blur-xl sm:p-6"
                            style={{
                                animation:
                                    "celebrationFadeUp .8s .45s ease-out both",
                            }}
                        >
                            <div className="flex items-start gap-4">
                                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-indigo-500 to-violet-600 text-xl shadow-lg shadow-indigo-500/20">
                                    🚀
                                </div>

                                <div>
                                    <h3 className="text-sm font-bold text-white sm:text-base">
                                        Artıq yolunuz başladı
                                    </h3>

                                    <p className="mt-1.5 text-xs leading-5 text-slate-400 sm:text-sm">
                                        artim.shop sizə alış-veriş, satış, elan
                                        yerləşdirmək və öz kiçik biznesinizi qurmaq
                                        üçün imkanlar təqdim edir.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* DAVAM ET */}
                        <div
                            className="mx-auto mt-7 max-w-xl pb-6"
                            style={{
                                animation:
                                    "celebrationFadeUp .8s .6s ease-out both",
                            }}
                        >
                            <button
                                type="button"
                                onClick={
                                    goToHome
                                }
                                className="group relative w-full overflow-hidden rounded-2xl bg-gradient-to-r from-indigo-600 via-violet-600 to-purple-600 px-6 py-4 text-sm font-bold text-white shadow-2xl shadow-indigo-600/30 transition-all duration-300 hover:scale-[1.02] hover:shadow-indigo-500/40 active:scale-[0.98]"
                            >
                                <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent transition-transform duration-700 group-hover:translate-x-full" />

                                <span className="relative flex items-center justify-center gap-2">
                                    Davam et
                                    <span className="text-lg transition-transform duration-300 group-hover:translate-x-1">
                                        →
                                    </span>
                                </span>
                            </button>

                            <div className="mt-4">
                                <div className="h-1.5 overflow-hidden rounded-full bg-white/10">
                                    <div
                                        className="h-full rounded-full bg-gradient-to-r from-indigo-400 via-violet-400 to-purple-400"
                                        style={{
                                            animation:
                                                "celebrationProgress 10s linear forwards",
                                        }}
                                    />
                                </div>

                                <div className="mt-6 flex justify-center">
                                    <div
                                        key={countdown}
                                        className="flex h-16 w-16 items-center justify-center rounded-full border border-violet-400/30 bg-violet-500/10 shadow-lg shadow-violet-500/20"
                                        style={{
                                            animation: "countdownPop 1s ease-out",
                                        }}
                                    >
                                        <span className="text-2xl font-bold text-white">
                                            {countdown}
                                        </span>
                                    </div>
                                </div>

                                <p className="mt-3 text-sm text-slate-400">
                                    saniyədən sonra əsas səhifəyə yönləndiriləcəksiniz...
                                </p>

                                <style>
                                    {`
        @keyframes countdownPop {
            0% {
                transform: scale(1.35);
                opacity: 0.3;
            }

            60% {
                transform: scale(0.95);
                opacity: 1;
            }

            100% {
                transform: scale(1);
                opacity: 1;
            }
        }
    `}
                                </style>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ANİMASİYALAR */}
                <style>{`
                    @keyframes celebrationFadeUp {
                        from {
                            opacity: 0;
                            transform: translateY(25px);
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }

                    @keyframes celebrationAvatar {
                        0% {
                            opacity: 0;
                            transform: scale(0.35) rotate(-12deg);
                        }
                        65% {
                            opacity: 1;
                            transform: scale(1.12) rotate(4deg);
                        }
                        100% {
                            opacity: 1;
                            transform: scale(1) rotate(0);
                        }
                    }

                    @keyframes celebrationConfetti {
                        0% {
                            transform: translate3d(0, -30px, 0) rotate(0deg);
                            opacity: 0;
                        }
                        10% {
                            opacity: 1;
                        }
                        100% {
                            transform: translate3d(80px, 110vh, 0) rotate(720deg);
                            opacity: 0;
                        }
                    }

                    @keyframes celebrationProgress {
                        from {
                            width: 0%;
                        }
                        to {
                            width: 100%;
                        }
                    }
                `}</style>
            </div>
        );
    }

    // =========================================================
    // INPUT CLASS
    // =========================================================
    const inputClass =
        "w-full rounded-2xl border border-slate-700/80 bg-slate-950/70 px-4 py-3.5 text-sm text-white placeholder:text-slate-500 outline-none transition-all duration-200 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10";

    return (
        <section className="relative min-h-screen overflow-hidden bg-slate-950 px-4 py-8 text-white sm:px-6 lg:px-8">

            {/* ARXA FON */}
            <div className="pointer-events-none absolute inset-0 overflow-hidden">

                <div className="absolute -left-32 -top-32 h-96 w-96 rounded-full bg-indigo-600/20 blur-3xl" />

                <div className="absolute -bottom-40 -right-32 h-96 w-96 rounded-full bg-violet-600/20 blur-3xl" />

                <div className="absolute left-1/2 top-1/3 h-80 w-80 -translate-x-1/2 rounded-full bg-blue-600/10 blur-3xl" />

                <div
                    className="absolute inset-0 opacity-[0.035]"
                    style={{
                        backgroundImage:
                            "linear-gradient(rgba(255,255,255,.8) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.8) 1px, transparent 1px)",
                        backgroundSize:
                            "40px 40px",
                    }}
                />
            </div>

            <div className="relative z-10 mx-auto w-full max-w-5xl">

                {/* BAŞLIQ */}
                <div className="mb-6 text-center sm:mb-8">

                    <div className="mb-4 inline-flex items-center rounded-full border border-indigo-500/20 bg-indigo-500/10 px-4 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-indigo-300">
                        Hesab yaradın
                    </div>

                    <h1 className="text-3xl font-black tracking-tight text-white sm:text-4xl lg:text-5xl">
                        Qeydiyyatdan keçin
                    </h1>

                    <p className="mx-auto mt-3 max-w-2xl text-sm leading-6 text-slate-400 sm:text-base">
                        Hesabınızı yaratmaq üçün aşağıdakı məlumatları düzgün şəkildə daxil edin.
                    </p>
                </div>

                {/* ƏSAS KART */}
                <div className="overflow-hidden rounded-[28px] border border-slate-800/80 bg-slate-900/80 shadow-2xl shadow-black/30 backdrop-blur-xl">

                    {/* KART BAŞLIĞI */}
                    <div className="border-b border-slate-800 bg-gradient-to-r from-indigo-600/10 via-violet-600/10 to-transparent px-5 py-5 sm:px-8">

                        <div className="flex items-center gap-3">

                            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-indigo-500 to-violet-600 text-lg font-bold shadow-lg shadow-indigo-500/20">
                                ✓
                            </div>

                            <div>
                                <h2 className="text-base font-bold text-white sm:text-lg">
                                    Şəxsi məlumatlar
                                </h2>

                                <p className="text-xs text-slate-500 sm:text-sm">
                                    Qeydiyyat üçün tələb olunan məlumatları daxil edin.
                                </p>
                            </div>
                        </div>
                    </div>

                    <form
                        onSubmit={
                            handleRegister
                        }
                        className="space-y-7 p-5 sm:p-8 lg:p-10"
                    >

                        {/* ÜMUMİ XƏTA */}
                        {formError && (
                            <div className="rounded-2xl border border-red-500/30 bg-red-500/10 p-4">

                                <div className="flex items-start gap-3">

                                    <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-red-500/15 text-red-400">
                                        !
                                    </div>

                                    <div className="min-w-0">
                                        <p className="font-semibold text-red-300">
                                            Qeydiyyat zamanı xəta baş verdi
                                        </p>

                                        <p className="mt-1 break-words text-sm leading-6 text-red-200/80">
                                            {
                                                formError
                                            }
                                        </p>
                                    </div>

                                    <button
                                        type="button"
                                        onClick={() =>
                                            setFormError(
                                                ""
                                            )
                                        }
                                        className="ml-auto rounded-lg p-1 text-red-300 transition hover:bg-red-500/10 hover:text-red-200"
                                        aria-label="Xətanı bağla"
                                    >
                                        <IoClose
                                            size={
                                                20
                                            }
                                        />
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* ŞƏXSİ MƏLUMATLAR */}
                        <div>

                            <div className="mb-4 flex items-center gap-2">

                                <div className="h-2 w-2 rounded-full bg-indigo-500" />

                                <h3 className="text-sm font-bold uppercase tracking-wider text-slate-200">
                                    Şəxsi məlumatlar
                                </h3>
                            </div>

                            <div className="grid grid-cols-1 gap-5 md:grid-cols-2">

                                {/* AD SOYAD */}
                                <div>

                                    <label
                                        htmlFor="name"
                                        className="mb-2 block text-sm font-semibold text-slate-300"
                                    >
                                        Ad və soyad
                                        <span className="ml-1 text-red-400">
                                            *
                                        </span>
                                    </label>

                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        placeholder="Adınızı və soyadınızı daxil edin"
                                        value={
                                            name
                                        }
                                        onChange={(
                                            e
                                        ) =>
                                            setName(
                                                e.target.value
                                            )
                                        }
                                        required
                                        autoComplete="name"
                                        className={
                                            inputClass
                                        }
                                    />
                                </div>

                                {/* ATA ADI */}
                                <div>

                                    <label
                                        htmlFor="faze"
                                        className="mb-2 block text-sm font-semibold text-slate-300"
                                    >
                                        Ata adı
                                        <span className="ml-1 text-red-400">
                                            *
                                        </span>
                                    </label>

                                    <input
                                        type="text"
                                        id="faze"
                                        name="faze"
                                        placeholder="Ata adınızı daxil edin"
                                        value={
                                            faze
                                        }
                                        onChange={(
                                            e
                                        ) =>
                                            setFaze(
                                                e.target.value
                                            )
                                        }
                                        required
                                        className={
                                            inputClass
                                        }
                                    />
                                </div>

                                {/* E-POÇT */}
                                <div>

                                    <label
                                        htmlFor="email"
                                        className="mb-2 block text-sm font-semibold text-slate-300"
                                    >
                                        E-poçt ünvanı
                                        <span className="ml-1 text-red-400">
                                            *
                                        </span>
                                    </label>

                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        placeholder="E-poçt ünvanınızı daxil edin"
                                        value={
                                            email
                                        }
                                        onChange={(
                                            e
                                        ) =>
                                            setEmail(
                                                e.target.value
                                            )
                                        }
                                        required
                                        autoComplete="email"
                                        className={
                                            inputClass
                                        }
                                    />
                                </div>

                                {/* FIN */}
                                <div>

                                    <label
                                        htmlFor="finCode"
                                        className="mb-2 block text-sm font-semibold text-slate-300"
                                    >
                                        FIN kodu
                                        <span className="ml-1 text-red-400">
                                            *
                                        </span>
                                    </label>

                                    <input
                                        type="text"
                                        id="finCode"
                                        name="finCode"
                                        placeholder="Şəxsiyyət vəsiqəsinin FIN kodu"
                                        value={
                                            finCode
                                        }
                                        onChange={(
                                            e
                                        ) =>
                                            setFinCode(
                                                e.target.value.toUpperCase()
                                            )
                                        }
                                        required
                                        maxLength={
                                            7
                                        }
                                        className={
                                            inputClass
                                        }
                                    />

                                    <p className="mt-2 text-xs text-slate-500">
                                        FIN kodunu şəxsiyyət vəsiqənizdə göstərildiyi kimi daxil edin.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* BÖLMƏ */}
                        <div className="h-px bg-gradient-to-r from-transparent via-slate-700 to-transparent" />

                        {/* ŞİFRƏ */}
                        <div>

                            <div className="mb-4 flex items-center gap-2">

                                <div className="h-2 w-2 rounded-full bg-violet-500" />

                                <h3 className="text-sm font-bold uppercase tracking-wider text-slate-200">
                                    Hesab təhlükəsizliyi
                                </h3>
                            </div>

                            <div className="grid grid-cols-1 gap-5 md:grid-cols-2">

                                {/* ŞİFRƏ */}
                                <div>

                                    <label
                                        htmlFor="password"
                                        className="mb-2 block text-sm font-semibold text-slate-300"
                                    >
                                        Şifrə
                                        <span className="ml-1 text-red-400">
                                            *
                                        </span>
                                    </label>

                                    <input
                                        type="password"
                                        id="password"
                                        name="password"
                                        placeholder="Ən azı 8 simvol"
                                        value={
                                            password
                                        }
                                        onChange={(
                                            e
                                        ) =>
                                            setPassword(
                                                e.target.value
                                            )
                                        }
                                        required
                                        minLength={
                                            8
                                        }
                                        autoComplete="new-password"
                                        className={
                                            inputClass
                                        }
                                    />

                                    <p className="mt-2 text-xs text-slate-500">
                                        Şifrəniz ən azı 8 simvoldan ibarət olmalıdır.
                                    </p>
                                </div>

                                {/* ŞİFRƏ TƏKRARI */}
                                <div>

                                    <label
                                        htmlFor="confirmPassword"
                                        className="mb-2 block text-sm font-semibold text-slate-300"
                                    >
                                        Şifrənin təkrarı
                                        <span className="ml-1 text-red-400">
                                            *
                                        </span>
                                    </label>

                                    <input
                                        type="password"
                                        id="confirmPassword"
                                        name="confirmPassword"
                                        placeholder="Şifrənizi yenidən daxil edin"
                                        value={
                                            confirmPassword
                                        }
                                        onChange={(
                                            e
                                        ) =>
                                            setConfirmPassword(
                                                e.target.value
                                            )
                                        }
                                        required
                                        autoComplete="new-password"
                                        className={`${inputClass} ${confirmPassword &&
                                            password !==
                                            confirmPassword
                                            ? "border-red-500/70 focus:border-red-500"
                                            : ""
                                            }`}
                                    />

                                    {confirmPassword &&
                                        password !==
                                        confirmPassword && (
                                            <p className="mt-2 text-xs text-red-400">
                                                Şifrələr eyni deyil.
                                            </p>
                                        )}
                                </div>
                            </div>
                        </div>

                        {/* DƏVƏT EDƏN */}
                        {referralCode && (
                            <>
                                <div className="h-px bg-gradient-to-r from-transparent via-slate-700 to-transparent" />

                                <div>

                                    <div className="mb-4 flex items-center gap-2">

                                        <div className="h-2 w-2 rounded-full bg-emerald-500" />

                                        <h3 className="text-sm font-bold uppercase tracking-wider text-slate-200">
                                            Dəvət edən şəxs
                                        </h3>
                                    </div>

                                    <div className="overflow-hidden rounded-2xl border border-emerald-500/20 bg-gradient-to-br from-emerald-500/10 via-slate-900 to-slate-950">

                                        {referralLoading ? (
                                            <div className="flex items-center gap-4 p-5">

                                                <div className="h-11 w-11 animate-pulse rounded-2xl bg-slate-800" />

                                                <div className="flex-1 space-y-2">

                                                    <div className="h-3 w-32 animate-pulse rounded bg-slate-800" />

                                                    <div className="h-3 w-48 animate-pulse rounded bg-slate-800" />
                                                </div>
                                            </div>
                                        ) : referralOwner ? (
                                            <div className="p-5">

                                                <div className="flex flex-col gap-4 sm:flex-row sm:items-center">

                                                    <div className="flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-600 text-xl font-bold text-white shadow-lg shadow-emerald-500/20">

                                                        {referralOwner?.photo ? (
                                                            <img
                                                                src={
                                                                    referralOwner.photo
                                                                }
                                                                alt="Dəvət edən şəxsin şəkli"
                                                                className="h-full w-full object-cover"
                                                            />
                                                        ) : (
                                                            String(
                                                                referralOwner?.name ||
                                                                "D"
                                                            )
                                                                .charAt(
                                                                    0
                                                                )
                                                                .toUpperCase()
                                                        )}
                                                    </div>

                                                    <div className="min-w-0 flex-1">

                                                        <div className="mb-1 flex flex-wrap items-center gap-2">

                                                            <p className="font-bold text-white">
                                                                {referralOwner?.name ||
                                                                    "Ad məlumatı yoxdur"}
                                                            </p>

                                                            <span className="rounded-full border border-emerald-500/20 bg-emerald-500/10 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-emerald-300">
                                                                Dəvət edən
                                                            </span>
                                                        </div>

                                                        <p className="break-all text-sm text-slate-400">
                                                            {referralOwner?.email ||
                                                                "E-poçt məlumatı yoxdur"}
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">

                                                    <div className="rounded-xl border border-slate-800 bg-slate-950/50 p-3">

                                                        <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">
                                                            Dəvət kodu
                                                        </p>

                                                        <p className="mt-1 break-all text-sm font-semibold text-emerald-300">
                                                            {
                                                                referralCode
                                                            }
                                                        </p>
                                                    </div>

                                                    <div className="rounded-xl border border-slate-800 bg-slate-950/50 p-3">

                                                        <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">
                                                            Status
                                                        </p>

                                                        <p className="mt-1 text-sm font-semibold text-emerald-300">
                                                            Dəvət linki aktivdir
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="p-5">

                                                <div className="flex items-start gap-3">

                                                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-red-500/10 text-red-400">
                                                        !
                                                    </div>

                                                    <div>

                                                        <p className="font-semibold text-red-300">
                                                            Dəvət edən şəxs tapılmadı
                                                        </p>

                                                        <p className="mt-1 break-words text-sm leading-6 text-red-200/70">
                                                            {referralError ||
                                                                "Dəvət koduna uyğun istifadəçi məlumatını almaq mümkün olmadı."}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {/* =================================================
                                        LİDER SEÇİMİ
                                    ================================================= */}
                                    {referralOwner && (
                                        <div className="mt-5 rounded-2xl border border-indigo-500/20 bg-indigo-500/5 p-5">

                                            <div className="mb-4">

                                                <h4 className="text-sm font-bold text-white">
                                                    Yerləşdirmə seçimi
                                                </h4>

                                                <p className="mt-1 text-xs leading-5 text-slate-500">
                                                    Yeni istifadəçinin komanda ağacında hansı liderin altında yerləşdiriləcəyini seçə bilərsiniz.
                                                </p>
                                            </div>

                                            {/* SEÇİMLƏR */}
                                            <div className="grid grid-cols-1 gap-3 md:grid-cols-2">

                                                {/* İSTİFADƏÇİ ÖZÜ SEÇİR */}
                                                <label
                                                    className={`relative flex cursor-pointer items-start gap-3 rounded-2xl border p-4 transition-all duration-200 ${leaderSelection ===
                                                        "manual"
                                                        ? "border-indigo-500 bg-indigo-500/10 shadow-lg shadow-indigo-500/5"
                                                        : "border-slate-700 bg-slate-950/50 hover:border-slate-600 hover:bg-slate-950"
                                                        }`}
                                                >

                                                    <input
                                                        type="radio"
                                                        name="leaderSelection"
                                                        value="manual"
                                                        checked={
                                                            leaderSelection ===
                                                            "manual"
                                                        }
                                                        onChange={() =>
                                                            handleLeaderSelectionChange(
                                                                "manual"
                                                            )
                                                        }
                                                        className="mt-1 h-4 w-4 shrink-0 accent-indigo-500"
                                                    />

                                                    <div>

                                                        <p className="text-sm font-bold text-white">
                                                            Lider kodunu özüm qeyd edəcəyəm
                                                        </p>

                                                        <p className="mt-1 text-xs leading-5 text-slate-500">
                                                            Özünüz müəyyən etdiyiniz liderin referral kodunu daxil edirsiniz. Sistem həmin lideri yoxlayaraq yerləşdirməni onun altında həyata keçirəcək.
                                                        </p>
                                                    </div>
                                                </label>

                                                {/* SİSTEM SEÇİR */}
                                                <label
                                                    className={`relative flex cursor-pointer items-start gap-3 rounded-2xl border p-4 transition-all duration-200 ${leaderSelection ===
                                                        "system"
                                                        ? "border-emerald-500 bg-emerald-500/10 shadow-lg shadow-emerald-500/5"
                                                        : "border-slate-700 bg-slate-950/50 hover:border-slate-600 hover:bg-slate-950"
                                                        }`}
                                                >

                                                    <input
                                                        type="radio"
                                                        name="leaderSelection"
                                                        value="system"
                                                        checked={
                                                            leaderSelection ===
                                                            "system"
                                                        }
                                                        onChange={() =>
                                                            handleLeaderSelectionChange(
                                                                "system"
                                                            )
                                                        }
                                                        className="mt-1 h-4 w-4 shrink-0 accent-emerald-500"
                                                    />

                                                    <div>

                                                        <p className="text-sm font-bold text-white">
                                                            Lideri sistem seçsin
                                                        </p>

                                                        <p className="mt-1 text-xs leading-5 text-slate-500">
                                                            Siz heç bir kod daxil etmirsiniz. Sistem dəvət edən şəxsin ağacında uyğun boş yeri avtomatik taparaq sizi yerləşdirir.
                                                        </p>
                                                    </div>
                                                </label>
                                            </div>

                                            {/* MANUAL INPUT */}
                                            {leaderSelection ===
                                                "manual" && (
                                                    <div className="mt-4">

                                                        <label
                                                            htmlFor="leaderCode"
                                                            className="mb-2 block text-sm font-semibold text-slate-300"
                                                        >
                                                            Lider kodu
                                                            <span className="ml-1 text-red-400">
                                                                *
                                                            </span>
                                                        </label>

                                                        <input
                                                            type="text"
                                                            id="leaderCode"
                                                            name="leaderCode"
                                                            placeholder="Liderin referral kodunu daxil edin"
                                                            value={
                                                                leaderCode
                                                            }
                                                            onChange={(
                                                                e
                                                            ) =>
                                                                setLeaderCode(
                                                                    e.target.value
                                                                )
                                                            }
                                                            required
                                                            autoComplete="off"
                                                            className={inputClass}
                                                        />

                                                        <div className="mt-3 rounded-xl border border-indigo-500/10 bg-indigo-500/5 p-3">

                                                            <p className="text-xs leading-5 text-indigo-200/80">
                                                                💡 Bu kod əsas dəvət kodundan fərqlidir. Əsas dəvət kodu sizi sayta dəvət edən şəxsi göstərir, lider kodu isə yeni hesabın ağacda hansı liderin altında yerləşdiriləcəyini müəyyən edir.
                                                            </p>
                                                        </div>
                                                    </div>
                                                )}

                                            {/* SYSTEM INFO */}
                                            {leaderSelection ===
                                                "system" && (
                                                    <div className="mt-4 flex items-start gap-3 rounded-xl border border-emerald-500/10 bg-emerald-500/5 p-3">

                                                        <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-emerald-500/10 text-emerald-400">
                                                            ✓
                                                        </div>

                                                        <div>

                                                            <p className="text-xs font-semibold text-emerald-300">
                                                                Avtomatik yerləşdirmə aktivdir
                                                            </p>

                                                            <p className="mt-1 text-xs leading-5 text-slate-500">
                                                                Sistem əvvəlcə uyğun boş yeri yoxlayacaq. Birbaşa yerlər doludursa, ağacın daha dərin hissələrində uyğun boş mövqe axtarılacaq.
                                                            </p>
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                    )}
                                </div>
                            </>
                        )}

                        {/* TELEFON VƏ KART */}
                        <div className="h-px bg-gradient-to-r from-transparent via-slate-700 to-transparent" />

                        <div>

                            <div className="mb-4 flex items-center gap-2">

                                <div className="h-2 w-2 rounded-full bg-blue-500" />

                                <h3 className="text-sm font-bold uppercase tracking-wider text-slate-200">
                                    Əlaqə və ödəniş məlumatları
                                </h3>
                            </div>

                            <div className="grid grid-cols-1 gap-5 md:grid-cols-2">

                                {/* TELEFON */}
                                <div>

                                    <label className="mb-2 block text-sm font-semibold text-slate-300">
                                        Telefon nömrəsi
                                        <span className="ml-1 text-red-400">
                                            *
                                        </span>
                                    </label>

                                    <PhoneInput
                                        country="az"
                                        value={
                                            phone
                                        }
                                        onChange={(
                                            value
                                        ) =>
                                            setPhone(
                                                value
                                            )
                                        }
                                        inputProps={{
                                            name: "phone",
                                            required: true,
                                            autoComplete:
                                                "tel",
                                        }}
                                        containerClass="w-full"
                                        inputClass="!h-[52px] !w-full !rounded-2xl !border !border-slate-700/80 !bg-slate-950/70 !text-sm !text-white"
                                        buttonClass="!rounded-l-2xl !border-slate-700/80 !bg-slate-950/70"
                                        dropdownClass="!bg-slate-900 !text-white"
                                        searchClass="!bg-slate-900 !text-white"
                                    />

                                    <p className="mt-2 text-xs text-slate-500">
                                        Aktiv istifadə etdiyiniz telefon nömrəsini daxil edin.
                                    </p>
                                </div>

                                {/* KART */}
                                <div>

                                    <label
                                        htmlFor="card"
                                        className="mb-2 block text-sm font-semibold text-slate-300"
                                    >
                                        Bank kartı
                                        <span className="ml-2 text-xs font-normal text-slate-500">
                                            (İstəyə bağlı)
                                        </span>
                                    </label>

                                    <input
                                        type="text"
                                        id="card"
                                        name="card"
                                        placeholder="Qazancların köçürülməsi üçün"
                                        value={
                                            card
                                        }
                                        onChange={(
                                            e
                                        ) =>
                                            setCard(
                                                e.target.value
                                            )
                                        }
                                        className={
                                            inputClass
                                        }
                                    />

                                    <p className="mt-2 text-xs text-slate-500">
                                        Bu məlumatı sonradan da əlavə edə bilərsiniz.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* CİNSİYYƏT VƏ FOTO */}
                        <div>

                            <div className="mb-4 flex items-center gap-2">

                                <div className="h-2 w-2 rounded-full bg-pink-500" />

                                <h3 className="text-sm font-bold uppercase tracking-wider text-slate-200">
                                    Əlavə məlumatlar
                                </h3>
                            </div>

                            <div className="grid grid-cols-1 gap-5 md:grid-cols-2">

                                {/* CİNSİYYƏT */}
                                <div>

                                    <label className="mb-2 block text-sm font-semibold text-slate-300">
                                        Cinsiyyət
                                        <span className="ml-1 text-red-400">
                                            *
                                        </span>
                                    </label>

                                    <div className="grid grid-cols-2 gap-3">

                                        <label
                                            className={`flex cursor-pointer items-center gap-3 rounded-2xl border p-4 transition-all ${gender ===
                                                "Kişi"
                                                ? "border-indigo-500 bg-indigo-500/10"
                                                : "border-slate-700 bg-slate-950/50 hover:border-slate-600"
                                                }`}
                                        >

                                            <input
                                                type="radio"
                                                name="gender"
                                                value="Kişi"
                                                onChange={(
                                                    e
                                                ) =>
                                                    setGender(
                                                        e
                                                            .target
                                                            .value
                                                    )
                                                }
                                                checked={
                                                    gender ===
                                                    "Kişi"
                                                }
                                                className="h-4 w-4 accent-indigo-500"
                                            />

                                            <span className="text-sm font-semibold text-slate-200">
                                                Kişi
                                            </span>
                                        </label>

                                        <label
                                            className={`flex cursor-pointer items-center gap-3 rounded-2xl border p-4 transition-all ${gender ===
                                                "Qadın"
                                                ? "border-pink-500 bg-pink-500/10"
                                                : "border-slate-700 bg-slate-950/50 hover:border-slate-600"
                                                }`}
                                        >

                                            <input
                                                type="radio"
                                                name="gender"
                                                value="Qadın"
                                                onChange={(
                                                    e
                                                ) =>
                                                    setGender(
                                                        e
                                                            .target
                                                            .value
                                                    )
                                                }
                                                checked={
                                                    gender ===
                                                    "Qadın"
                                                }
                                                className="h-4 w-4 accent-pink-500"
                                            />

                                            <span className="text-sm font-semibold text-slate-200">
                                                Qadın
                                            </span>
                                        </label>
                                    </div>
                                </div>

                                {/* FOTO */}
                                <div>

                                    <label className="mb-2 block text-sm font-semibold text-slate-300">
                                        Profil şəkli
                                        <span className="ml-2 text-xs font-normal text-slate-500">
                                            (İstəyə bağlı)
                                        </span>
                                    </label>

                                    <div
                                        {...getRootProps({
                                            className: `flex min-h-[104px] cursor-pointer items-center justify-center rounded-2xl border-2 border-dashed px-4 py-4 text-center transition-all ${isDragActive
                                                ? "border-indigo-400 bg-indigo-500/10"
                                                : "border-slate-700 bg-slate-950/50 hover:border-indigo-500/60 hover:bg-indigo-500/5"
                                                }`,
                                        })}
                                    >

                                        <input
                                            {...getInputProps()}
                                        />

                                        {photo ? (
                                            <div className="flex w-full items-center gap-3">

                                                <div className="flex h-12 w-12 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-slate-800">

                                                    <img
                                                        src={URL.createObjectURL(
                                                            photo
                                                        )}
                                                        alt="Seçilmiş profil şəkli"
                                                        className="h-full w-full object-cover"
                                                    />
                                                </div>

                                                <div className="min-w-0 flex-1 text-left">

                                                    <p className="truncate text-sm font-semibold text-slate-200">
                                                        {
                                                            photo.name
                                                        }
                                                    </p>

                                                    <p className="mt-1 text-xs text-emerald-400">
                                                        Şəkil seçildi
                                                    </p>
                                                </div>

                                                <button
                                                    type="button"
                                                    onClick={(
                                                        e
                                                    ) => {
                                                        e.stopPropagation();

                                                        handleClearUploadPhoto();
                                                    }}
                                                    className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-red-500/10 text-red-400 transition hover:bg-red-500/20"
                                                    aria-label="Şəkli sil"
                                                >
                                                    <IoClose
                                                        size={
                                                            20
                                                        }
                                                    />
                                                </button>
                                            </div>
                                        ) : (
                                            <div>

                                                <div className="mx-auto mb-2 flex h-10 w-10 items-center justify-center rounded-xl bg-indigo-500/10 text-indigo-400">
                                                    ↑
                                                </div>

                                                <p className="text-sm font-semibold text-slate-300">
                                                    {isDragActive
                                                        ? "Şəkli buraya buraxın"
                                                        : "Şəkil seçmək üçün klikləyin"}
                                                </p>

                                                <p className="mt-1 text-xs text-slate-500">
                                                    Maksimum ölçü: 50 MB
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* ŞƏRTLƏR */}
                        <div className="h-px bg-gradient-to-r from-transparent via-slate-700 to-transparent" />

                        <div className="rounded-2xl border border-slate-800 bg-slate-950/40 p-4">

                            <label
                                htmlFor="terms"
                                className="flex cursor-pointer items-start gap-3"
                            >

                                <input
                                    type="checkbox"
                                    id="terms"
                                    checked={
                                        acceptedTerms
                                    }
                                    onChange={(
                                        e
                                    ) =>
                                        setAcceptedTerms(
                                            e
                                                .target
                                                .checked
                                        )
                                    }
                                    required
                                    className="mt-1 h-4 w-4 shrink-0 cursor-pointer accent-indigo-500"
                                />

                                <span className="text-sm leading-6 text-slate-400">

                                    <button
                                        type="button"
                                        onClick={(
                                            e
                                        ) => {
                                            e.preventDefault();

                                            toggleTermsModal();
                                        }}
                                        className="font-semibold text-indigo-400 transition hover:text-indigo-300"
                                    >
                                        Şərtlər və qaydalar
                                    </button>{" "}
                                    ilə razıyam.
                                </span>
                            </label>

                            <button
                                type="button"
                                onClick={
                                    toggleTermsModal
                                }
                                className="ml-7 mt-2 text-xs font-semibold text-slate-500 transition hover:text-indigo-400"
                            >
                                Şərtləri və qaydaları oxu
                            </button>
                        </div>

                        {/* QEYDİYYAT DÜYMƏSİ */}
                        <button
                            type="submit"
                            disabled={
                                isLoading ||
                                !acceptedTerms
                            }
                            className="group relative w-full overflow-hidden rounded-2xl bg-gradient-to-r from-indigo-600 via-violet-600 to-purple-600 px-5 py-4 text-sm font-bold text-white shadow-xl shadow-indigo-600/20 transition-all duration-300 hover:scale-[1.01] hover:shadow-indigo-600/30 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:scale-100"
                        >

                            <span className="relative z-10 flex items-center justify-center gap-2">

                                {isLoading ? (
                                    <>
                                        <span className="h-5 w-5 animate-spin rounded-full border-2 border-white/30 border-t-white" />

                                        Qeydiyyat tamamlanır...
                                    </>
                                ) : (
                                    <>
                                        Qeydiyyatdan keç

                                        <span className="transition-transform duration-200 group-hover:translate-x-1">
                                            →
                                        </span>
                                    </>
                                )}
                            </span>
                        </button>

                        {!acceptedTerms && (
                            <p className="text-center text-xs text-amber-400/80">
                                Qeydiyyat düyməsini aktivləşdirmək üçün şərtlər və qaydaları qəbul edin.
                            </p>
                        )}
                    </form>

                    {/* ALT HİSSƏ */}
                    <div className="border-t border-slate-800 bg-slate-950/30 px-5 py-6 sm:px-8">

                        <p className="text-center text-sm text-slate-500">
                            Artıq hesabınız var?

                            <button
                                type="button"
                                onClick={() =>
                                    navigation(
                                        "/login"
                                    )
                                }
                                className="ml-2 font-semibold text-indigo-400 transition hover:text-indigo-300"
                            >
                                Giriş edin
                            </button>
                        </p>

                        <p className="mt-3 text-center text-sm text-slate-500">
                            Sayta qayıtmaq istəyirsiniz?

                            <button
                                type="button"
                                onClick={() =>
                                    navigation(
                                        "/"
                                    )
                                }
                                className="ml-2 font-semibold text-violet-400 transition hover:text-violet-300"
                            >
                                Əsas səhifəyə qayıt
                            </button>
                        </p>
                    </div>
                </div>
            </div>

            {/* ŞƏRTLƏR MODALI */}
            {showTerms && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm"
                    onClick={
                        closeTermsModal
                    }
                >
                    <div
                        className="relative max-h-[90vh] w-full max-w-2xl overflow-hidden rounded-3xl border border-slate-700 bg-slate-900 shadow-2xl shadow-black/50"
                        onClick={(e) =>
                            e.stopPropagation()
                        }
                    >

                        {/* MODAL BAŞLIQ */}
                        <div className="flex items-center justify-between border-b border-slate-800 px-5 py-4 sm:px-6">

                            <div>

                                <h3 className="text-lg font-bold text-white sm:text-xl">
                                    Şərtlər və qaydalar
                                </h3>

                                <p className="mt-1 text-xs text-slate-500">
                                    Qeydiyyatdan əvvəl bu məlumatları diqqətlə oxuyun.
                                </p>
                            </div>

                            <button
                                type="button"
                                onClick={
                                    closeTermsModal
                                }
                                className="flex h-10 w-10 items-center justify-center rounded-xl bg-slate-800 text-slate-400 transition hover:bg-slate-700 hover:text-white"
                                aria-label="Pəncərəni bağla"
                            >
                                <IoClose
                                    size={
                                        22
                                    }
                                />
                            </button>
                        </div>

                        {/* MODAL MƏZMUNU */}
                        <div className="max-h-[60vh] overflow-y-auto px-5 py-6 sm:px-6">

                            <div className="space-y-4">

                                <div className="rounded-2xl border border-slate-800 bg-slate-950/50 p-4">

                                    <h4 className="font-semibold text-white">
                                        Ödəniş siyasəti
                                    </h4>

                                    <p className="mt-2 text-sm leading-6 text-slate-400">
                                        Bütün ödənişləri təsdiqləməzdən əvvəl məlumatları diqqətlə yoxlayın. Ödənişin geri qaytarılması ilə bağlı tətbiq olunan qaydalar əməliyyatın şərtlərindən asılıdır.
                                    </p>
                                </div>

                                <div className="rounded-2xl border border-slate-800 bg-slate-950/50 p-4">

                                    <h4 className="font-semibold text-white">
                                        Qazanc sistemi
                                    </h4>

                                    <p className="mt-2 text-sm leading-6 text-slate-400">
                                        Dəvət sistemi və digər qazanc mexanizmləri platformanın müəyyən etdiyi qaydalara əsasən hesablanır. Qazancın hesablanması sistemdə qeydə alınan fəaliyyətlərə uyğun həyata keçirilir.
                                    </p>
                                </div>

                                <div className="rounded-2xl border border-slate-800 bg-slate-950/50 p-4">

                                    <h4 className="font-semibold text-white">
                                        Məlumatların təhlükəsizliyi
                                    </h4>

                                    <p className="mt-2 text-sm leading-6 text-slate-400">
                                        Hesab məlumatlarınızın təhlükəsizliyinin qorunması üçün müvafiq texniki tədbirlər tətbiq edilir. Qanunvericiliyin tələb etdiyi hallar istisna olmaqla şəxsi məlumatların qorunması təmin edilir.
                                    </p>
                                </div>

                                <div className="rounded-2xl border border-slate-800 bg-slate-950/50 p-4">

                                    <h4 className="font-semibold text-white">
                                        Hesabın məhdudlaşdırılması
                                    </h4>

                                    <p className="mt-2 text-sm leading-6 text-slate-400">
                                        Platformanın qaydalarının pozulması hesabın müvəqqəti məhdudlaşdırılmasına və ya digər tədbirlərin görülməsinə səbəb ola bilər.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* MODAL DÜYMƏLƏRİ */}
                        <div className="border-t border-slate-800 bg-slate-950/30 p-5 sm:p-6">

                            <button
                                type="button"
                                onClick={
                                    acceptTerms
                                }
                                className="w-full rounded-2xl bg-gradient-to-r from-indigo-600 to-violet-600 py-3.5 text-sm font-bold text-white shadow-lg shadow-indigo-600/20 transition hover:from-indigo-500 hover:to-violet-500"
                            >
                                Şərtləri qəbul edirəm
                            </button>

                            <button
                                type="button"
                                onClick={
                                    closeTermsModal
                                }
                                className="mt-3 w-full rounded-2xl border border-slate-700 bg-slate-800 py-3.5 text-sm font-semibold text-slate-300 transition hover:bg-slate-700 hover:text-white"
                            >
                                Bağla
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default Register;